import { useEffect, useState } from "react";
import { ProfileType } from "../../options-table/types/ProfileType";
import {
    useAppSidePanelContextProvider
} from "../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import { StateToggleButton } from "./StateToggleButton";
import { Stack } from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';

export function BalanceProfilesSelector() {
    const {
        selectedPortfolio,
        updateSelectedPortfolio,
        saveSelectedPortfolio
    } = useAppSidePanelContextProvider();
    
    const [isCurrentBalanceVisible, setIsCurrentBalanceVisible] = useState<boolean>(false);
    const [isCustomBalanceVisible, setIsCustomBalanceVisible] = useState<boolean>(false);
    const [isExpirationBalanceVisible, setIsExpirationBalanceVisible] = useState<boolean>(false);

    useEffect(() => {
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            setIsCurrentBalanceVisible(
                selectedPortfolio.portfolioSettings.selectedProfileTypes
                    .some(x => x === ProfileType.Current));

            setIsCustomBalanceVisible(
                selectedPortfolio.portfolioSettings.selectedProfileTypes
                    .some(x => x === ProfileType.Custom));

            setIsExpirationBalanceVisible(
                selectedPortfolio.portfolioSettings.selectedProfileTypes
                    .some(x => x === ProfileType.Expiration));
        }
    }, [selectedPortfolio]);
    
    const onChangeHandle = async (profileType: ProfileType): Promise<void> => {
        if (selectedPortfolio === null || selectedPortfolio.portfolioSettings === null)
            return;
        
        let isSwitchOn: boolean = false;
        
        switch(profileType) {
            case ProfileType.Current:
                isSwitchOn = isCurrentBalanceVisible;
                setIsCurrentBalanceVisible(!isCurrentBalanceVisible);
                break;

            case ProfileType.Custom:
                isSwitchOn = isCustomBalanceVisible;
                setIsCustomBalanceVisible(!isCustomBalanceVisible);
                break;

            case ProfileType.Expiration:
                isSwitchOn = isExpirationBalanceVisible;
                setIsExpirationBalanceVisible(!isExpirationBalanceVisible);
                break;
        }

        if (isSwitchOn) {
            selectedPortfolio.portfolioSettings.selectedProfileTypes =
                selectedPortfolio.portfolioSettings.selectedProfileTypes
                    .filter(x => x !== profileType);
        } else {
            selectedPortfolio.portfolioSettings.selectedProfileTypes.push(profileType);
        }
        
        updateSelectedPortfolio();
        saveSelectedPortfolio();
    }
    
    return (
        <Stack direction="row" spacing={0.5}>
            <StateToggleButton
                isSwitchOn={isCurrentBalanceVisible}
                onChangeHandle={async () => await onChangeHandle(ProfileType.Current)}
                switchOnTooltip="Hide current balance"
                switchOffTooltip="Show current balance"
            >
                <MoreHorizIcon sx={{
                    height: '18px',
                    width: '18px',
                }}/>
            </StateToggleButton>
            <StateToggleButton
                isSwitchOn={isCustomBalanceVisible}
                onChangeHandle={async () => await onChangeHandle(ProfileType.Custom)}
                switchOnTooltip="Hide custom balance"
                switchOffTooltip="Show custom balance"
            >
                <LinearScaleIcon sx={{
                    height: '18px',
                    width: '18px',
                }}/>
            </StateToggleButton>
            <StateToggleButton
                isSwitchOn={isExpirationBalanceVisible}
                onChangeHandle={async () => await onChangeHandle(ProfileType.Expiration)}
                switchOnTooltip="Hide expiration balance"
                switchOffTooltip="Show expiration balance"
            >
                <HorizontalRuleIcon sx={{
                    height: '18px',
                    width: '18px',
                }}/>
            </StateToggleButton>
        </Stack>
    );
}

